(function () {
  function bind(root) {
    if (!root || root.dataset.bound === '1') return;
    var rail = root.querySelector('[data-exhibit-rail]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-exhibit-item]'));
    var prev = root.querySelector('[data-exhibit-prev]');
    var next = root.querySelector('[data-exhibit-next]');
    if (!rail || items.length === 0) return;
    root.dataset.bound = '1';

    var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var few = items.length < 2;

    function step() {
      var first = items[0];
      if (!first) return 280;
      var styles = window.getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function itemInView(el) {
      var railBox = rail.getBoundingClientRect();
      var box = el.getBoundingClientRect();
      var slop = 10;
      return box.width > 1 && box.left >= railBox.left - slop && box.right <= railBox.right + slop;
    }

    function setPeek(el, peek) {
      el.classList.toggle('is-peek', peek);
      if (peek) el.setAttribute('aria-hidden', 'true');
      else el.removeAttribute('aria-hidden');
      el.querySelectorAll('a, button').forEach(function (node) {
        if (peek) node.setAttribute('tabindex', '-1');
        else node.removeAttribute('tabindex');
      });
    }

    function syncItems() {
      items.forEach(function (el) {
        setPeek(el, !few && !itemInView(el));
      });
    }

    function sync() {
      syncItems();
      if (!prev || !next) return;
      if (few) {
        prev.hidden = true;
        next.hidden = true;
        return;
      }
      prev.hidden = false;
      next.hidden = false;
      var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
    }

    function go(dir) {
      if (few) return;
      rail.scrollBy({
        left: dir * step(),
        behavior: motion.matches ? 'auto' : 'smooth'
      });
    }

    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        go(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        go(1);
      });
    }

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(-1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(1);
      }
    });

    rail.addEventListener('scroll', sync, { passive: true });
    rail.addEventListener('scrollend', sync);
    window.addEventListener('resize', sync);
    if ('ResizeObserver' in window) {
      new ResizeObserver(sync).observe(rail);
    }

    sync();
  }

  function scan(node) {
    (node || document).querySelectorAll('[data-home-exhibit]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
